export const GET_ALL_HANDLERS = 'GET_ALL_HANDLERS';
export const GET_ALL_LAYOUTS = 'GET_ALL_LAYOUTS';
export const GET_ALL_CONTAINERS = 'GET_ALL_CONTAINERS';
export const GET_ALL_OFFER_TYPES = 'GET_ALL_OFFER_TYPES';
export const GET_SITES = 'GET_SITES';
export const GET_SITES_BY_OFFER_ID = 'GET_SITES_BY_OFFER_ID';
export const GET_OFFER_BLOCK_SUMMARY_BY_OFFER_ID = 'GET_OFFER_BLOCK_SUMMARY_BY_OFFER_ID';
